var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 50.2 46.9",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 50.2 46.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paso1",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(79 228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M12.3 43.4H18V30.3c0-.2.1-.3.2-.4.1-.1.3-.2.4-.2H31c.2 0 .3.1.4.2.1.1.2.3.2.4v13.1h5.7c.5 0 .9-.4.9-.9V22.8L24.8 9.4 11.4 22.8v19.7c0 .5.4.9.9.9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ec2cad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(7.378 21.958)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 1.1,
    y: 0.9,
    width: 32.7,
    height: 23.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.1,
    y: 0.9,
    width: 32.7,
    height: 23.5,
    id: "mask-2_00000092416088379635239360000011340464245014886288_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000051374092603952114900000018445061439925933751_",
    className: "st2",
    d: "M1.1.9h32.7v23.5H1.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M30.8.9v19.7c0 .5-.4.9-.9.9h-5.7v1.9c0 .2-.1.3-.2.4 0 .1-.2.2-.4.2H11.2c-.2 0-.3-.1-.4-.2-.1-.1-.2-.3-.2-.4v-1.9H4.9c-.5-.1-.9-.5-.9-1V.9L1.1 3.8v16.7c0 2.1 1.7 3.8 3.8 3.8h25c2.1 0 3.8-1.7 3.8-3.8V3.8L30.8.9z",
    mask: "url(#mask-2_00000092416088379635239360000011340464245014886288_)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000053533114694371575410000012102797097356023184_",
    filterUnits: "userSpaceOnUse",
    x: 1.1,
    y: 0.9,
    width: 47.4,
    height: 28.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.1,
    y: 0.9,
    width: 47.4,
    height: 28.8,
    id: "mask-4_00000173851771206160922250000011830304393705566081_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter_00000053533114694371575410000012102797097356023184_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3_00000030466078194823556450000000505692883623650972_",
    className: "st2",
    d: "M1.1.9h47.4v28.8H1.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "m2.3 27.5 2.2 2.2 3.9-3.9 2.9-2.9L24.8 9.4l13.4 13.4 2.9 2.9 3.9 3.9 2.2-2.2c1.6-1.6 1.6-4.2 0-5.8L29.9 4.3l-2.2-2.2c-.8-.8-1.8-1.2-2.9-1.2-1 0-2.1.4-2.9 1.2l-2.2 2.2L2.3 21.7c-1.6 1.6-1.6 4.2 0 5.8",
    mask: "url(#mask-4_00000173851771206160922250000011830304393705566081_)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M31.5 29.9c-.1-.1-.3-.2-.4-.2H18.6c-.2 0-.3.1-.4.2-.2.1-.2.3-.2.4v15c0 .2.1.3.2.4.1.1.3.2.4.2H31c.2 0 .3-.1.4-.2.1-.1.2-.3.2-.4v-15c0-.1 0-.3-.1-.4",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHouse);
export default __webpack_public_path__ + "static/media/icon-house.9cfa5b0eba39f64c94f5fc89b80b7a87.svg";
export { ForwardRef as ReactComponent };